<div class="shrink-container">
  <mat-icon svgIcon="expand-up-double" [class.pet-hidden]="isPetCardsHidden"
  (click)="petCardsVisibilityToggle()"></mat-icon>
</div>

<div class="container">
  <div class="header">
    @for (route of tabRoutes; track route) {
      <div class="item" [class.active]="route.active"
        (click)="navigateToRoute(tabRoutes,route)">
        <p>{{ route.title | translate }}</p>
      </div>
    }
  </div>

  <div class="content" #scrollableContent>
    <router-outlet></router-outlet>
  </div>
</div>
